import React from "react";
import { GetCheckInDetailDataType } from "../../../../redux/mySpace/mySpaceTypes";
import CustomizedAvatar from "../../../commons/CircularAvatar/CustomizedAvatar";
import {
  BriefCase,
  IdBadge,
  InterviewStatusIcon,
  LoctionRedIcon,
  NoticeCalendarIcon,
} from "../../../../assets/images";
import { CircularAvatar } from "../../../commons";
import { reverseDate } from "../../../../utils/commonFunctions";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

type AppProps = {
  singleCheckInScheduleDetails: GetCheckInDetailDataType;
};
const UserDetails = ({ singleCheckInScheduleDetails }: AppProps) => {
  return (
    <div>
      <div
        className="row ml-3 d-flex flex-column mt-4"
        style={{
          width: "93%",
        }}
      >
        <div
          className="pt-4 pl-4 pr-4"
          style={{
            border: "1px solid #bfcbe1",
            borderRadius: "4px",
            marginLeft: "5px",
            marginBottom: "22px",
            alignItems: "center",
          }}
        >
          <div className="d-flex align-items-center mb-3">
            <div>
              <CustomizedAvatar
                name={`${singleCheckInScheduleDetails?.updated_by?.first_name}${singleCheckInScheduleDetails?.updated_by?.last_name}`}
                image={
                  singleCheckInScheduleDetails?.updated_by?.profile_pic &&
                  singleCheckInScheduleDetails?.updated_by?.profile_pic
                    ?.file_url
                }
                style={{ width: "65px", fontSize: "20px" }}
              />
            </div>
            <div className="ml-3">
              <span
                style={{
                  fontSize: "16px",
                  color: "#262a44",
                  lineHeight: "16px",
                  fontWeight: "500",
                  marginBottom: "5px",
                  display: "inline-block",
                }}
              >
                {`${singleCheckInScheduleDetails?.updated_by?.first_name} ${singleCheckInScheduleDetails?.updated_by?.last_name}`}
              </span>

              <p style={{ fontSize: "13px", color: "#6e7491", margin: "0px" }}>
                {`${
                  singleCheckInScheduleDetails?.updated_by?.job_title
                    ? singleCheckInScheduleDetails?.updated_by?.job_title
                    : ""
                }  ${
                  singleCheckInScheduleDetails?.updated_by?.job_title &&
                  singleCheckInScheduleDetails?.updated_by?.department
                    ? "|"
                    : ""
                } ${
                  singleCheckInScheduleDetails?.updated_by?.department
                    ? singleCheckInScheduleDetails?.updated_by?.department
                    : ""
                }`}
              </p>
            </div>
          </div>
          <div>
            <div className="inside-card-header d-flex w-100 p-3">
              <div
                className="feedBack-heading d-flex align-items-center"
                style={{ width: "50%" }}
              >
                <img src={BriefCase} alt="" className="mr-3" />
                <div>Employee ID</div>
              </div>

              <div style={{ width: "50%" }}>
                {singleCheckInScheduleDetails?.updated_by?.employee_id ? (
                  <span className="sent">
                    {singleCheckInScheduleDetails?.updated_by?.employee_id}
                  </span>
                ) : (
                  "NA"
                )}
              </div>
            </div>

            <div className="inside-card-header d-flex w-100 p-3">
              <div
                className="feedBack-heading d-flex align-items-center"
                style={{ width: "50%" }}
              >
                <img src={InterviewStatusIcon} alt="" className="mr-3" />
                <div>Reporting To</div>
              </div>
              <div style={{ width: "50%" }}>
                <div className="d-flex align-items-center">
                  <div>
                    <CircularAvatar
                      name={`${singleCheckInScheduleDetails?.manager?.first_name} ${singleCheckInScheduleDetails?.manager?.last_name}`}
                      image={
                        singleCheckInScheduleDetails?.manager?.profile_pic &&
                        singleCheckInScheduleDetails?.manager.profile_pic
                          ?.file_url
                      }
                    />
                  </div>
                  <span className="ml-2">
                    {`${singleCheckInScheduleDetails?.manager?.first_name} ${singleCheckInScheduleDetails?.manager?.last_name}`}
                  </span>
                </div>
              </div>
            </div>
            <div className="inside-card-header d-flex w-100 p-3">
              <span
                className="feedBack-heading d-flex align-items-center"
                style={{ width: "50%" }}
              >
                <img src={LoctionRedIcon} alt="" className="mr-3" />
                <div>Job Location</div>
              </span>
              <div style={{ width: "50%" }}>
                {singleCheckInScheduleDetails?.updated_by?.branch_name
                  ? singleCheckInScheduleDetails?.updated_by?.branch_name
                  : "NA"}
              </div>
            </div>

            <div className="inside-card-header d-flex w-100 p-3">
              <span
                className="feedBack-heading d-flex align-items-center"
                style={{ width: "50%" }}
              >
                <img src={InterviewStatusIcon} alt="" className="mr-3" />
                <div>Employment Status</div>
              </span>
              <div style={{ width: "50%" }}>
                <span
                  className={
                    singleCheckInScheduleDetails?.updated_by
                      ?.employment_status === "Full time"
                      ? `status-complete`
                      : singleCheckInScheduleDetails?.updated_by
                          ?.employment_status === "Part time"
                      ? "status-incomplete"
                      : singleCheckInScheduleDetails?.updated_by
                          ?.employment_status === "Intern"
                      ? "status-approval-pending"
                      : singleCheckInScheduleDetails?.updated_by
                          ?.employment_status === "Probation"
                      ? "manufacturing-journal"
                      : singleCheckInScheduleDetails?.updated_by
                          ?.employment_status === "Articleship"
                      ? "status-other"
                      : ""
                  }
                  style={{
                    borderRadius: "16px",
                    textAlign: "center",
                    marginTop: "5px",
                  }}
                >
                  {singleCheckInScheduleDetails?.updated_by?.employment_status
                    ? singleCheckInScheduleDetails?.updated_by
                        ?.employment_status
                    : "NA"}
                </span>
              </div>
            </div>
            <div className="inside-card-header d-flex w-100 p-3">
              <span
                className="feedBack-heading d-flex align-items-center"
                style={{ width: "50%" }}
              >
                <img src={NoticeCalendarIcon} alt="" className="mr-3" />
                <div>Check In Date</div>
              </span>
              <div style={{ width: "50%" }}>
                {singleCheckInScheduleDetails?.date
                  ? singleCheckInScheduleDetails?.date
                  : "NA"}
              </div>
            </div>
            <div className="inside-card-header d-flex w-100 p-3">
              <span
                className="feedBack-heading d-flex align-items-center"
                style={{ width: "50%" }}
              >
                <img src={InterviewStatusIcon} alt="" className="mr-3" />
                <div>Comment Added By</div>
              </span>
              <div style={{ width: "50%" }}>
                {singleCheckInScheduleDetails?.feedback_by?.first_name ? (
                  <div className="d-flex align-items-center">
                    <div>
                      <CircularAvatar
                        name={`${
                          singleCheckInScheduleDetails?.feedback_by?.first_name
                        } ${
                          singleCheckInScheduleDetails?.feedback_by?.last_name
                            ? singleCheckInScheduleDetails?.feedback_by
                                ?.last_name
                            : ""
                        }`}
                        image={
                          singleCheckInScheduleDetails?.feedback_by
                            ?.profile_pic &&
                          singleCheckInScheduleDetails?.feedback_by.profile_pic
                            ?.file_url
                        }
                      />
                    </div>
                    <span className="ml-2">
                      {`${
                        singleCheckInScheduleDetails?.feedback_by?.first_name
                      } ${
                        singleCheckInScheduleDetails?.feedback_by?.last_name
                          ? singleCheckInScheduleDetails?.feedback_by?.last_name
                          : ""
                      }`}
                    </span>
                  </div>
                ) : (
                  "NA"
                )}
              </div>
            </div>
            <div className="inside-card-header d-flex w-100 p-3 align-items-start">
              <span
                className="feedBack-heading d-flex align-items-center"
                style={{ width: "50%" }}
              >
                <img src={IdBadge} alt="" className="mr-3" />
                <div>Comment</div>
              </span>
              <div style={{ width: "50%" }}>
                {singleCheckInScheduleDetails?.feedback
                  ? singleCheckInScheduleDetails?.feedback
                  : "NA"}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserDetails;
